import type { SystemDataSequence } from "building-types/dataSequences/dataSequence";
import { systemDataSequenceNew } from "building-types/dataSequences/dataSequenceTools";
import type { SystemDataSequenceId } from "building-types/dataSequences/systemDataSequenceTypes";
import { SystemDataSequenceIds } from "building-types/dataSequences/systemDataSequenceTypes";
import type { Group } from "building-types/groups/group";
import type { RWTable, Table } from "common/data/table";
import { docEntityHandleHash } from "./entity/core/handleHash";

export const SystemDataSequences = SystemDataSequenceIds.reduce((acc, id) => {
  acc[id] = systemDataSequenceNew(id as SystemDataSequenceId);
  return acc;
}, {} as RWTable<SystemDataSequence>);

export const SystemDataSequenceGroup: Group = {
  id: "systemDataSequenceGroup",
  name: "Built-in Data Sequences",
  entityType: "GROUP",
  sortIndex: 0,
  isBuiltIn: true,
};

export const SystemDataSequenceEntityGroups: Table<Group["id"]> = Object.keys(SystemDataSequences).reduce(
  (acc, id) => {
    acc[docEntityHandleHash({ type: "DATA_SEQUENCE", id })] = SystemDataSequenceGroup.id;
    return acc;
  },
  {} as RWTable<Group["id"]>,
);
